import React from "react";
import { Helmet } from "react-helmet";
import Top from "../hooks/topping";

const Terms = () => {
  return (
    <div className="bft-main put-margin inner">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Terms of Service - Nzvedaz BFT Marketplace</title>
      </Helmet>
      <div className="bft-container bft-content">
        <h4>
          Terms of Service
          <i className="fa fa-info pointer bft-right bft-large"></i>
        </h4>
        <hr />
        <p>Last updated:&nbsp;08/12/2021&nbsp;</p>
        <ol>
          <li>
            <strong>Introduction</strong>
          </li>
          <li>
            Welcome to&nbsp;Nzvedaz Big Five&nbsp;Token website&nbsp;(
            <strong>&ldquo;Site&rdquo;</strong>), owned
            and&nbsp;operated&nbsp;by&nbsp;Nzvedaz Big Five&nbsp;Token Limited.
            d/b/a&nbsp;Nzvedaz Big Five&nbsp;Token (
            <strong>&ldquo;Nzvedaz Big Five&nbsp;Token&rdquo;</strong>,&nbsp;
            <strong>&ldquo;we&rdquo;</strong>,&nbsp;
            <strong>&ldquo;us&rdquo;</strong>or&nbsp;
            <strong>&ldquo;our&rdquo;</strong>). We at&nbsp;Nzvedaz Big
            Five&nbsp;Token strive&nbsp;to&nbsp;maintain&nbsp;the highest level
            of compliance. These Terms of Service (
            <strong>&ldquo;Terms&rdquo;</strong>) govern users&rsquo; access to
            and use of the Site including without limitation:&nbsp;
          </li>
          <li>
            the creation, purchase, sale (including by way of auction (
            <strong>&ldquo;Auction&rdquo;</strong>)&nbsp;in accordance
            with&nbsp;our&nbsp;Auction&nbsp;rules, exchange,
            or&nbsp;modification of unique non-fungible tokens, implemented on
            blockchain networks (<strong>&ldquo;Networks&rdquo;</strong>), such
            as&nbsp;Binance&nbsp;Smart Chain using smart contracts (
            <strong>&ldquo;Crypto Assets&rdquo;</strong>) on our&nbsp;platform (
            <strong>&ldquo;Platform&rdquo;</strong>);&nbsp;
          </li>
          <li>our&nbsp;online and/or&nbsp;mobile services; and&nbsp;&nbsp;</li>
        </ol>
        <ul>
          <li>
            software provided on or&nbsp;in connection with those
            services,&nbsp;
          </li>
        </ul>
        <p>
          (Collectively, the&nbsp;<strong>&ldquo;Service&rdquo;</strong>).&nbsp;
        </p>
        <ol start="2">
          <li>
            A detailed description of the Service is set out in section 4
            below.&nbsp;
          </li>
          <li>
            YOU SHALL&nbsp;READ THESE TERMS CAREFULLY BEFORE ACCESSING THE
            PLATFORM AND/OR&nbsp;USING THE SERVICE AND&nbsp;REVIEW THE TERMS
            PERIODICALLY AND&nbsp;REGULARLY FOR&nbsp;CHANGES. BY ACCESSING THE
            PLATFORM AND/OR&nbsp;USING THE SERVICE YOU AGREE TO BE BOUND BY
            THESE TERMS AND AGREE THAT SUCH TERMS CONSTITUTE A LEGALLY BINDING
            AGREEMENT BETWEEN YOU AND US. IF YOU DO NOT AGREE TO BE FULLY BOUND
            BY THESE TERMS YOU MUST NOT ACCESS THE PLATFORM AND/OR&nbsp;USE THE
            SERVICE.&nbsp;
          </li>
          <li>
            IF YOU ARE ACCEPTING THESE TERMS ON BEHALF OF A COMPANY
            OR&nbsp;OTHER&nbsp;LEGAL ENTITY, YOU&nbsp;REPRESENT THAT YOU HAVE
            THE LEGAL AUTHORITY TO ACCEPT THE TERMS ON THAT ENTITY&rsquo;S
            BEHALF, IN WHICH CASE&nbsp;<strong>&ldquo;YOU&rdquo;</strong>WILL
            MEAN THAT ENTITY. IF YOU DO NOT HAVE THIS AUTHORITY OR&nbsp;IF YOU
            DO NOT AGREE TO BE FULLY BOUND BY THESE TERMS, YOU MUST NOT ACCESS
            THE PLATFORM AND/OR&nbsp;USE THE SERVICE.&nbsp;
          </li>
          <li>
            THE BIG FIVE&nbsp;TOKEN RESERVES&nbsp;THE RIGHT TO CHANGE OR MODIFY
            THESE TERMS FROM TIME TO TIME. IF WE MAKE CHANGES TO THESE TERMS, WE
            WILL NOT PROVIDE NOTICE OF SUCH CHANGES AND THE AMENDED TERMS SHALL
            HAVE IMMEDIATE EFFECT UPON BEING POSTED ON THE SITE, SUBJECT TO ANY
            APPLICABLE LAW. BY CONTINUING TO ACCESS THE PLATFORM AND/OR USE THE
            SERVICE, YOU CONFIRM YOUR ACCEPTANCE OF THE REVISED TERMS AND ALL OF
            THE TERMS INCORPORATED THEREIN BY REFERENCE. WE ENCOURAGE YOU TO
            REVIEW THE TERMS FREQUENTLY TO ENSURE THAT YOU UNDERSTAND THE TERMS
            AND CONDITIONS THAT APPLY WHEN YOU ACCESS THE PLATFORM AND/OR USE
            THE SERVICE. ALL USERS SHALL IMMEDIATELY DISCONTINUE THEIR USE OF
            THE SERVICE SHOULD THEY DISAGREE TO BE FULLY BOUND BY THE AMENDED
            TERMS.&nbsp;
          </li>
          <li>
            <strong>Privacy Policy</strong>
          </li>
        </ol>
        <p>
          Please refer to our&nbsp;Privacy Policy&nbsp;for information about how
          we collect,&nbsp;use&nbsp;and share personal information about
          you&nbsp;
        </p>
        <ol start="3">
          <li>
            <strong>Eligibility and Compliance</strong>
          </li>
          <li>
            You must access the Platform and/or&nbsp;use the Service&nbsp;in
            accordance with&nbsp;the Terms, in addition to the law of
            your&nbsp;country of&nbsp;residence, country of citizenship, and any
            other&nbsp;relevant law that&nbsp;is applicable&nbsp;to you.&nbsp;
          </li>
          <li>
            It is your&nbsp;sole&nbsp;responsibility to check and ensure
            whether&nbsp;you are legally&nbsp;permitted&nbsp;to access the
            Platform and/or&nbsp;use the Service under&nbsp;the law of
            your&nbsp;country of&nbsp;residence, country of citizenship, and any
            other&nbsp;relevant law that&nbsp;is applicable&nbsp;to you.&nbsp;
          </li>
          <li>
            When you connect a wallet (as described in section 7 below),
            you&nbsp;represent&nbsp;and warrant (collectively referred to as
            the&nbsp;
            <strong>&ldquo;Representations and Warranties&rdquo;</strong>)
            to&nbsp;Nzvedaz Big Five&nbsp;Token that:&nbsp;
          </li>
          <li>
            You are 18 years of age or&nbsp;more and&nbsp;possess&nbsp;the
            capacity to form a binding contract, and have the full capacity to
            accept these Terms, use the Service and conduct any transactions on
            the Platform (<strong>&ldquo;Transaction&rdquo;</strong>);&nbsp;
          </li>
          <li>
            If&nbsp;requested by us, you will provide us
            with&nbsp;accurate,&nbsp;true&nbsp;and complete information about
            yourself (including, but not limited to, your&nbsp;name and email
            address);&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            If you are an individual using the Service, you are not using the
            Service as an agent, proxy, or&nbsp;otherwise on behalf of
            another&nbsp;user&nbsp;and you have sole and complete control,
            access and ownership of all keys and passwords to your&nbsp;Account
            (as defined in section 7.1 below);&nbsp;
          </li>
        </ul>
        <ol>
          <li>
            If you are&nbsp;representing&nbsp;a company or&nbsp;other&nbsp;legal
            entity, you are acting as their&nbsp;authorized&nbsp;representative,
            and both you and the entity you&nbsp;represent&nbsp;will be bound by
            and&nbsp;comply with&nbsp;these Terms;&nbsp;
          </li>
          <li>
            Your&nbsp;access to the Platform, use of the Service and all
            activities being conducted on the Platform are and will be in full
            compliance with these Terms and all&nbsp;relevant laws
            and&nbsp;regulations, and such access, use and activities are not
            prohibited by any applicable laws or&nbsp;regulations, and is not
            for&nbsp;any illegal or&nbsp;immoral purposes;&nbsp;
          </li>
          <li>
            By accessing the Platform and/or using the
            Service,&nbsp;you&nbsp;have not, and will not, infringe any
            representations, covenants,&nbsp;restrictions&nbsp;and rights of any
            other party;&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            You have obtained, all&nbsp;rights, licenses, consents, permissions,
            power&nbsp;and/or&nbsp;authority necessary or&nbsp;otherwise to
            create, sell,&nbsp;buy&nbsp;or&nbsp;exchange the Crypto
            Assets.&nbsp;
          </li>
          <li>
            You have and will continue to abide by the law of your&nbsp;country
            of&nbsp;residence, country of citizenship, and any
            other&nbsp;relevant law that&nbsp;is applicable&nbsp;to You,
            including but not limited to&nbsp;reporting any trading activities
            or&nbsp;profits for&nbsp;taxation purposes;&nbsp;
          </li>
        </ul>
        <ol>
          <li>
            You have not been suspended or&nbsp;removed from any
            other&nbsp;exchange (whether&nbsp;crypto-exchange or&nbsp;otherwise)
            for&nbsp;any&nbsp;reason;&nbsp;
          </li>
          <li>
            You are experienced in Crypto Assets and understand the&nbsp;risks
            involved in Transactions involving Crypto Assets including but not
            limited to, the&nbsp;risk of&nbsp;purchasing&nbsp;counterfeit
            assets, mislabeled assets, assets that are vulnerable to metadata
            decay, assets on smart contracts with bugs, and assets that may
            become untransferable;&nbsp;
          </li>
          <li>
            You have received or had access to all necessary independent legal
            and financial advice prior to using the Service and have not relied
            and will not rely on any statements, announcements, notices,
            advertisements, materials and/or information as published
            by&nbsp;Nzvedaz Big Five&nbsp;Token to&nbsp;enter&nbsp;any
            Transaction; and&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            You have not and will not be accessing the Platform with any device,
            software or&nbsp;system that alters your&nbsp;IP address to be
            different from your&nbsp;physical location.&nbsp;
          </li>
        </ul>
        <ol start="4">
          <li>
            <strong>The Service</strong>
          </li>
          <li>
            Nzvedaz Big Five&nbsp;Token offers&nbsp;a decentralized platform for
            the creation, purchase, sale, exchange, or modification of unique
            non-fungible tokens, implemented on the Networks using smart
            contracts.&nbsp;Nzvedaz Big Five&nbsp;Token
            only&nbsp;provides&nbsp;a Platform
            to&nbsp;facilitate&nbsp;Transactions between you and other users,
            but&nbsp;Nzvedaz Big Five&nbsp;Token will&nbsp;not be storing or
            holding any Crypto Assets on behalf of any user. Users will be able
            to access Crypto Asset prices, trade information
            and&nbsp;utilize&nbsp;any trading agreements as made available on
            the Platform&nbsp;to&nbsp;conduct a Transaction. All Transactions
            are executed by the participating users&nbsp;in accordance
            with&nbsp;the terms and conditions of the smart contract between and
            as&nbsp;determined&nbsp;by the participating users.&nbsp;
          </li>
          <li>
            The Platform may be accessible via website. The Service is being
            offered on a self-service basis, subject to payment of the Fees. All
            users must ensure they access the Platform from a secure and
            trustworthy source or&nbsp;device.&nbsp;
          </li>
          <li>
            The Service will only be accessible after the users have performed
            the Procedure (as defined in section 7.1). Users must&nbsp;comply
            with&nbsp;the Procedure, which&nbsp;Nzvedaz Big Five&nbsp;Token
            may&nbsp;change from time-to-time. Failure to do so may result in
            failure in accessing the Service.&nbsp;
          </li>
          <li>
            Nzvedaz Big Five&nbsp;Token is&nbsp;unable to control the quality of
            Crypto Assets involved in any Transaction, the authenticity or
            accuracy of the Transaction information, or the ability of each
            party to a Transaction to fulfil each of their obligations in their
            agreement. You&nbsp;are responsible for&nbsp;checking the trade
            details, your trading counterparty&rsquo;s details,
            the&nbsp;price&nbsp;and nature of the Crypto Assets and/or your own
            risk appetite prior to&nbsp;entering&nbsp;any Transaction.&nbsp;
          </li>
          <li>
            <strong>Using the Service</strong>
          </li>
          <li>
            Usage of the Service will incur&nbsp;fees (the&nbsp;
            <strong>&ldquo;Service Fees&rdquo;</strong>). The Service Fees
            include:&nbsp;
          </li>
          <li>A percentage fee when Transactions occur; and&nbsp;</li>
          <li>Royalty fees.&nbsp;</li>
        </ol>
        <p>
          Nzvedaz Big Five&nbsp;Token reserves&nbsp;the right to make any
          changes to the Service Fees without prior notice. Users&nbsp;are
          responsible for&nbsp;checking the Fee Schedule regularly before
          executing any Transaction that may incur Service Fees. The Service
          Fees will not include third party fees that may arise out of or in
          connection with the creation,&nbsp;sale&nbsp;or exchange of Crypto
          Assets.&nbsp;
        </p>
        <ol>
          <li>
            You must&nbsp;provide&nbsp;all equipment and software necessary to
            access the Platform and/or&nbsp;use the Service, including but not
            limited to, a mobile device that is suitable to access the Platform
            and/or&nbsp;use the Service. You are solely&nbsp;responsible
            for&nbsp;any fees, including internet connection or&nbsp;mobile
            fees, that you incur&nbsp;when using the Service.&nbsp;
          </li>
          <li>
            You agree that&nbsp;Nzvedaz Big Five&nbsp;Token assumes&nbsp;no
            responsibility and accepts no liability to you or any third parties
            in connection with any suspension, termination, cancellation or
            freezing of your Account&nbsp;pursuant to&nbsp;section 6 below, and
            that on the occurrence of such an event:&nbsp;
          </li>
          <li>
            Nzvedaz Big Five&nbsp;Token is&nbsp;not obliged to keep
            or&nbsp;disclose&nbsp;to you any information from within your
            Account;&nbsp;
          </li>
          <li>
            Subject to our Privacy Policy,&nbsp;Nzvedaz Big Five&nbsp;Token
            may&nbsp;continue to keep your User Information (as defined in
            section 16.2) and all the Transaction information from your use of
            the Service;&nbsp;
          </li>
          <li>
            Nzvedaz Big Five&nbsp;Token has&nbsp;the right
            to&nbsp;delete&nbsp;unfulfilled Transactions agreed with another
            user before suspension or termination;&nbsp;
          </li>
          <li>
            You will&nbsp;immediately&nbsp;arrange to disconnect any Account you
            have connected to the Platform.&nbsp;Nzvedaz Big Five&nbsp;Token
            shall&nbsp;not be responsible for any loss associated with your
            Account; and&nbsp;
          </li>
          <li>
            All rights and licenses granted hereunder to you
            shall&nbsp;terminate&nbsp;immediately&nbsp;and&nbsp;Nzvedaz Big
            Five&nbsp;Token shall&nbsp;be entitled to disconnect you from the
            Platform.&nbsp;
          </li>
          <li>
            You may only use the Service by linking your&nbsp;digital wallet on
            supported bridge extensions such as&nbsp;MetaMask&nbsp;(
            <u>
              <a href="https://metamask.io/" className="link-dark">
                https://metamask.io/
              </a>
            </u>
            ). We will ask you to download a supported electronic wallet
            extension and connect and unlock your&nbsp;digital wallets with that
            extension. Once you&nbsp;submit&nbsp;an order&nbsp;to sell
            or&nbsp;purchase&nbsp;a Crypto Asset, your&nbsp;order&nbsp;is passed
            on to the applicable extension, which completes the Transaction on
            your&nbsp;behalf.&nbsp;
          </li>
          <li>
            ALL TRANSACTIONS ON THE PLATFORM ARE FACILITATED AND&nbsp;RUN BY
            THIRD-PARTY ELECTRONIC WALLET EXTENSIONS. BY USING THE SERVICE, YOU
            ACKNOWLEDGE AND AGREE THAT YOU ARE GOVERNED BY THE TERMS OF SERVICE
            AND PRIVACY POLICY FOR&nbsp;THE APPLICABLE EXTENSIONS.
            FOR&nbsp;METAMASK, THOSE TERMS ARE AVAILABLE AT (
            <u>
              <a href="https://metamask.io/terms.html" className="link-dark">
                https://metamask.io/terms.html
              </a>
            </u>
            ) AND (
            <u>
              <a href="https://metamask.io/privacy.html" className="link-dark">
                https://metamask.io/privacy.html
              </a>
            </u>
            ).&nbsp;
          </li>
          <li>
            The Service may not be available, or the Platform may not be
            accessible depending on the user&rsquo;s residence, geographic
            location, and/or nationality (which may be&nbsp;determined&nbsp;by
            the user&rsquo;s IP address).&nbsp;
          </li>
          <li>
            <strong>Suspension of your&nbsp;use of Service</strong>
          </li>
        </ol>
        <p>
          You agree that&nbsp;Nzvedaz Big Five&nbsp;Token has&nbsp;full
          discretion at any time, for any reason and without prior notification
          to you to suspend or&nbsp;terminate&nbsp;your access to the Platform
          and/or part or&nbsp;all&nbsp;the Service, including but not limited to
          compliance with law, in response to a subpoena, court order or other
          binding governmental or regulatory order, or to enforce transaction
          limits and to temporarily or permanently freeze (cancel) your
          permission to use your Account.&nbsp;
        </p>
        <ol start="7">
          <li>
            <strong>Wallet and Security</strong>
          </li>
          <li>
            To use the Service, you will need to open an account (
            <strong>&ldquo;Account&rdquo;</strong>) by connecting
            your&nbsp;wallet. After&nbsp;connecting your&nbsp;wallet, you will
            be prompted for&nbsp;a signature&nbsp;request
            for&nbsp;authentication. After&nbsp;signing and [ticking the box
            that you have&nbsp;read and understood the Terms you will be
            authenticated and your&nbsp;Account will be opened (the&nbsp;
            <strong>&ldquo;Procedure&rdquo;</strong>).&nbsp;
          </li>
          <li>
            You are solely responsible for the equipment, services, software,
            applications, such as&nbsp;MetaMask&nbsp;or any third-party product
            or service that you use to access your Account. You are liable for
            all activities taking place in your Account, including but not
            limited to information disclosure, online agreements, or purchase of
            Crypto Assets or digital assets from any service providers to your
            wallet. You must&nbsp;immediately&nbsp;notify us&nbsp;if you
            discover or otherwise suspect any security breaches related to your
            Account and/or the Service.&nbsp;Nzvedaz Big Five&nbsp;Token
            will&nbsp;block multiple Accounts of the same user.&nbsp;
          </li>
          <li>You agree that you will not:&nbsp;</li>
          <li>
            Create another&nbsp;Account if&nbsp;we&rsquo;ve&nbsp;disabled one
            you had unless you have our&nbsp;written permission first;&nbsp;
          </li>
          <li>
            Buy, sell,&nbsp;rent&nbsp;or&nbsp;lease access to your&nbsp;Account
            unless you have our&nbsp;written permission first;&nbsp;
          </li>
        </ol>
        <ul>
          <li>Share your&nbsp;Account with anyone; and&nbsp;</li>
        </ul>
        <ol>
          <li>
            Log in or&nbsp;try to log in to access the Service through
            unauthorized third-party applications or&nbsp;clients.&nbsp;
          </li>
          <li>
            You are solely responsible for keeping your Account secure. You
            must&nbsp;utilise&nbsp;all reasonable efforts to protect your
            Account, including without limitation,
            any&nbsp;unauthorised&nbsp;access or use of personally identifiable
            information. We recommend that you keep your Account password secure
            and always log-off from the Platform when leaving the device through
            which you accessed the Platform. You are&nbsp;advised to
            use&nbsp;various security measures to protect your
            Account.&nbsp;If&nbsp;your Account is breached or compromised, you
            shall&nbsp;decide&nbsp;to protect your Account
            and/or&nbsp;discontinue&nbsp;any connection between your Account and
            the Platform. You agree and acknowledge that you are solely
            responsible for any damages arising from or relating to any
            authorized or unauthorized use of your Account.&nbsp;
          </li>
          <li>
            <strong>Anti-Money Laundering</strong>
          </li>
          <li>
            Nzvedaz Big Five&nbsp;Token may&nbsp;require you
            to&nbsp;provide&nbsp;additional&nbsp;information and documents at
            the request of any competent authority or in case of application of
            any applicable law or regulation, including laws related to
            anti-money laundering, or for counteracting financing of
            terrorism.&nbsp;Nzvedaz Big Five&nbsp;Token may&nbsp;also require
            you to&nbsp;provide&nbsp;additional&nbsp;information and documents
            in cases where it has reasons to believe that:&nbsp;
          </li>
          <li>
            Your&nbsp;Account is being used for&nbsp;money laundering
            or&nbsp;for&nbsp;any other&nbsp;illegal activity; or&nbsp;
          </li>
          <li>
            Transactions performed via your&nbsp;Account were performed in
            breach of these Terms.&nbsp;
          </li>
          <li>
            In such cases,&nbsp;Nzvedaz Big Five&nbsp;Token,&nbsp;in its sole
            discretion, may pause or cancel your Transactions and suspend your
            access to the Platform and/or use of the Service until
            such&nbsp;additional&nbsp;information and documents are reviewed
            by&nbsp;Nzvedaz Big Five&nbsp;Token and&nbsp;accepted as satisfying
            the requirements of the applicable law. If you do
            not&nbsp;provide&nbsp;complete and&nbsp;accurate&nbsp;information
            and documents in response to such a request within a reasonable
            timeframe, your Account shall be&nbsp;terminated.&nbsp;
          </li>
          <li>
            <strong>Communications</strong>
          </li>
          <li>
            By creating an Account, you consent to receive electronic
            communications from&nbsp;Nzvedaz Big Five&nbsp;Token (e.g., via
            email or by posting notices to the Service). These communications
            may include notices about your Account (e.g., such as transactional
            information) and are part of your relationship with us. You agree
            that any notices, agreements, disclosures, or other communications
            that we send to you electronically will satisfy any legal
            communication requirements, including, but not limited to, that such
            communications be in writing. You should maintain copies of
            electronic communications from us by printing a paper copy or saving
            an electronic copy. We may also send you promotional communications
            via email, including, but not limited to, newsletters, special
            offers, surveys and other news and information we think will be of
            interest to you. You may opt out of receiving these promotional
            emails at any time by contacting us
            at&nbsp;support@thebigfivetoken.com&nbsp;
          </li>
          <li>
            By&nbsp;submitting&nbsp;personal data to us, you agree to the terms
            of our&nbsp;Privacy Policy and you expressly consent to the
            collection, use and disclosure of your&nbsp;personal data&nbsp;in
            accordance with&nbsp;the Privacy Policy.&nbsp;
          </li>
          <li>
            <strong>Ownership</strong>
          </li>
          <li>
            Unless otherwise&nbsp;indicated&nbsp;in writing by us, the&nbsp;Big
            Five&nbsp;Token logo&nbsp;and all designs, text, graphics, pictures,
            information, data, software embodied (including all source and
            object code) in the Service or Platform, sound files, other files
            and the selection and arrangement thereof (collectively,&nbsp;
            <strong>&ldquo;Content&rdquo;</strong>) are the proprietary property
            of&nbsp;Nzvedaz Big Five&nbsp;Token or&nbsp;our
            affiliates,&nbsp;licensors&nbsp;or users, as applicable and is
            protected by copyright,&nbsp;trademark&nbsp;and other intellectual
            property laws. Nothing in these Terms shall grant the user any of
            such property rights and/or ownership rights and shall not be an
            assignment of such rights.&nbsp;
          </li>
          <li>
            Notwithstanding anything to the contrary in these Terms, the
            Platform, Service, and Content may include software components
            provided by&nbsp;Nzvedaz Big Five&nbsp;Token or&nbsp;its affiliates
            or a third party that are subject to separate license terms, in
            which case those license terms will govern such software
            components.&nbsp;
          </li>
          <li>
            The Content that may appear on the Service and/or Platform are
            trademarks of&nbsp;Nzvedaz Big Five&nbsp;Token or&nbsp;our
            affiliates and may not be copied,&nbsp;imitated&nbsp;or used, in
            whole or in part, without our prior written permission. You may not
            use any metatags or other&nbsp;
            <strong>&ldquo;hidden text&rdquo;&nbsp;</strong>utilizing&nbsp;
            <strong>&ldquo;Nzvedaz Big Five&nbsp;Token&rdquo;</strong>or any
            other name, trademark or product or service name of&nbsp;Nzvedaz Big
            Five&nbsp;Token or&nbsp;our affiliates without our prior written
            permission. In addition, the look and feel of the Content,
            including, without limitation, all page headers, custom graphics,
            button icons and scripts, constitute the service mark, trademark or
            trade dress of&nbsp;Nzvedaz Big Five&nbsp;Token and&nbsp;may not be
            copied,&nbsp;imitated&nbsp;or used, in whole or in part, without our
            prior written permission. All other trademarks, registered
            trademarks, product names and&nbsp;Nzvedaz Big Five&nbsp;Token
            names&nbsp;or logos mentioned on the Platform are the property of
            their respective owners and may not be copied,&nbsp;imitated&nbsp;or
            used, in whole or in part, without the permission of the applicable
            trademark holder. Reference to any products, services, processes or
            other information by name, trademark, manufacturer, supplier or
            otherwise does not constitute or imply
            endorsement,&nbsp;sponsorship&nbsp;or recommendation by&nbsp;Nzvedaz
            Big Five&nbsp;Token.&nbsp;
          </li>
          <li>
            Any rights with respect to the Content which are not expressly
            granted&nbsp;herein&nbsp;are reserved by&nbsp;Nzvedaz Big
            Five&nbsp;Token.&nbsp;
          </li>
          <li>
            <strong>
              License to Access the Platform and Use Our&nbsp;Service and
              Content
            </strong>
          </li>
          <li>
            You are hereby granted a limited, non-exclusive, non-transferable,
            non-sublicensable, non-perpetual, personal and&nbsp;revocable
            license to access the Platform, use the Service and Content.
            However, the license is subject to these Terms and does not include
            any&nbsp;right to:&nbsp;
          </li>
          <li>
            sell,&nbsp;resell&nbsp;or&nbsp;commercially use the Service
            or&nbsp;Content;&nbsp;
          </li>
          <li>
            distribute, publicly&nbsp;perform&nbsp;or&nbsp;publicly display any
            Content;&nbsp;
          </li>
          <li>
            modify or&nbsp;otherwise make any derivative uses of the Service
            or&nbsp;Content, or&nbsp;any&nbsp;portion&nbsp;thereof;&nbsp;
          </li>
          <li>
            use any data mining,&nbsp;robots or&nbsp;similar&nbsp;data gathering
            or&nbsp;extraction methods;&nbsp;
          </li>
          <li>
            download (other&nbsp;than page caching) any&nbsp;portion&nbsp;of the
            Site, except as expressly&nbsp;permitted&nbsp;by us; and&nbsp;
          </li>
          <li>
            use the Service or&nbsp;Content other&nbsp;than
            for&nbsp;their&nbsp;intended purposes.&nbsp;
          </li>
          <li>
            You shall not&nbsp;remove any copyright, trademark
            or&nbsp;other&nbsp;proprietary notices that have been placed on the
            Site.&nbsp;
          </li>
          <li>
            You shall not exploit the Service in any&nbsp;unauthorised&nbsp;way
            whatsoever, including but not limited to trespass or&nbsp;materially
            burden network&nbsp;capacity.&nbsp;
          </li>
          <li>
            <strong>Hyperlinks</strong>
          </li>
        </ol>
        <p>
          You are granted a limited, nonexclusive, nontransferable right to
          create a text hyperlink through the Service for non-commercial
          purposes, provided that such link does not portray&nbsp;Nzvedaz Big
          Five&nbsp;Token or&nbsp;our affiliates or any of our products or
          services in a false, misleading,&nbsp;derogatory&nbsp;or otherwise
          defamatory manner, and&nbsp;provided&nbsp;further that the linked site
          does not&nbsp;contain&nbsp;any adult or illegal material or any
          material that is offensive, harassing or otherwise objectionable. This
          limited right may be revoked at any time. You may not use a logo or
          other proprietary graphic of&nbsp;Nzvedaz Big Five&nbsp;Token
          to&nbsp;link to the Service or Content without our express written
          permission. Further, you may not use,&nbsp;frame&nbsp;or utilize
          framing techniques to enclose any&nbsp;Nzvedaz Big Five&nbsp;Token
          trademark,&nbsp;logo&nbsp;or other proprietary information, including
          the images found on the Platform, the content of any text or the
          layout or design of any page, or form contained on a page without our
          express written consent.&nbsp;
        </p>
        <ol start="13">
          <li>
            <strong>Notifications and Third-Party Service</strong>
          </li>
          <li>
            All of&nbsp;Nzvedaz Big Five Token&nbsp;&rsquo;s notifications will
            be made&nbsp;publicly known&nbsp;at the Site.&nbsp;If&nbsp;any
            notification relates to any changes in the Service, the Platform,
            Fees and/or&nbsp;Nzvedaz Big Five&nbsp;Token,&nbsp;such notification
            shall be effective&nbsp;immediately&nbsp;upon being posted on the
            Site. It is your sole responsibility to check from time to time for
            new notifications on the Website.&nbsp;
          </li>
          <li>
            Notwithstanding anything to the contrary in these Terms, the Service
            and Content may include software components provided by&nbsp;Nzvedaz
            Big Five&nbsp;Token or&nbsp;its affiliates or a third party that are
            subject to separate license terms, in which case those license terms
            will govern such software components. For example, when you click to
            get more details about any of the Crypto Assets sold through the
            Platform, you will notice a&nbsp;third-party&nbsp;link to the
            website from which such Crypto Asset originated. Such website may
            include license terms governing the use of such Crypto Asset. In the
            event you&nbsp;purchase&nbsp;such Crypto Asset through the Platform,
            you&nbsp;are required to&nbsp;comply with&nbsp;such terms.&nbsp;
          </li>
          <li>
            The Service may&nbsp;contain&nbsp;links to third-party websites (
            <strong>&ldquo;Third-Party Websites&rdquo;</strong>) and
            applications (&ldquo;Third-Party Applications&rdquo;). When you
            click on a link to a Third-Party Website or Third-Party Application,
            we will not warn you that you have left our Site. These Terms and
            policies will no longer govern you and you will be subject to the
            terms and conditions (including privacy policies) of the Third-Party
            Website or destination. Such Third-Party Websites and Third-Party
            Applications are not under the control of&nbsp;Nzvedaz Big
            Five&nbsp;Token.&nbsp;Nzvedaz Big Five&nbsp;Token is&nbsp;not
            responsible for any Third-Party Websites or Third-Party
            Applications.&nbsp;Nzvedaz Big Five&nbsp;Token provides&nbsp;these
            Third-Party Websites and Third-Party Applications only as a
            convenience and does not review, approve, monitor,
            endorse,&nbsp;warrant, or make any representations with respect to
            Third-Party Websites or Third-Party Applications, or their products
            or services. You use all links in Third-Party Websites, and
            Third-Party Applications at your own risk. You should review all
            applicable agreements and policies, including privacy and data
            gathering practices, of any Third-Party Websites or Third-Party
            Applications, and should make whatever investigation you feel
            necessary or&nbsp;appropriate before&nbsp;proceeding&nbsp;with any
            transaction with any third party.&nbsp;
          </li>
          <li>
            <strong>User&nbsp;Conduct</strong>
          </li>
          <li>
            You agree that you will not violate any law, contract, intellectual
            property or&nbsp;other&nbsp;third party&nbsp;right, and that you are
            solely&nbsp;responsible for&nbsp;your&nbsp;conduct, while using the
            Service. You agree that you will abide by these Terms and will
            not:&nbsp;
          </li>
          <li>
            Provide&nbsp;false or misleading information to&nbsp;Nzvedaz Big
            Five&nbsp;Token;&nbsp;
          </li>
          <li>
            Create Crypto Asset names, listings and their&nbsp;descriptions,
            smart contract names, and collections including profanity
            or&nbsp;overtly sexual content;&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            Use or&nbsp;attempt&nbsp;to use another user&rsquo;s account without
            authorization from such user and&nbsp;Nzvedaz Big
            Five&nbsp;Token;&nbsp;
          </li>
        </ul>
        <ol>
          <li>Create or&nbsp;list counterfeit items;&nbsp;&nbsp;</li>
          <li>
            Pose as another&nbsp;person or&nbsp;create a misleading
            username;&nbsp;
          </li>
          <li>
            Use the Service in any manner&nbsp;that could interfere with,
            disrupt, negatively&nbsp;affect&nbsp;or&nbsp;inhibit
            other&nbsp;users from fully enjoying the Service, or&nbsp;that could
            damage, disable,&nbsp;overburden&nbsp;or&nbsp;impair&nbsp;the
            functioning of the Service in any manner;&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            Develop,&nbsp;utilize, or&nbsp;disseminate&nbsp;any software,
            or&nbsp;interact with any Application Programming Interface (
            <strong>&ldquo;API&rdquo;</strong>) in any manner, that could
            damage, harm, or&nbsp;impair&nbsp;the Service;&nbsp;
          </li>
          <li>
            Reverse engineer&nbsp;any aspect of the Service, or&nbsp;do anything
            that might discover&nbsp;source code or&nbsp;bypass
            or&nbsp;circumvent measures employed to prevent or&nbsp;limit access
            to any Service,&nbsp;area&nbsp;or&nbsp;code of the Service;&nbsp;
          </li>
        </ul>
        <ol>
          <li>
            Attempt to circumvent any content-filtering techniques we employ,
            or&nbsp;attempt&nbsp;to access any feature or&nbsp;area of the
            Platform and/or&nbsp;Service that you are not authorized to
            access;&nbsp;
          </li>
          <li>
            Use any&nbsp;robot, spider, crawler, scraper, script,
            browser&nbsp;extension,
            offline&nbsp;reader&nbsp;or&nbsp;other&nbsp;automated means
            or&nbsp;interface not authorized by us to access the Platform
            and/or&nbsp;Service, extract data or&nbsp;otherwise interfere with
            or&nbsp;modify&nbsp;the&nbsp;rendering of the Site&rsquo;s pages
            or&nbsp;functionality;&nbsp;
          </li>
          <li>
            Use data collected from the Platform and/or&nbsp;Service to contact
            individuals, companies, or&nbsp;other&nbsp;persons
            or&nbsp;entities;&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            Use data collected from the Platform and/or&nbsp;Service
            for&nbsp;any direct marketing activity (including without
            limitation, email marketing, SMS marketing, telemarketing, and
            direct marketing);&nbsp;
          </li>
          <li>
            Bypass or&nbsp;ignore instructions that control all automated access
            to the Platform and/or&nbsp;Service;&nbsp;
          </li>
          <li>
            Use the Platform and/or&nbsp;Service for&nbsp;any illegal
            or&nbsp;unauthorized purpose, or&nbsp;engage
            in,&nbsp;encourage&nbsp;or&nbsp;promote any activity that violates
            these Terms;&nbsp;
          </li>
        </ul>
        <ol>
          <li>
            Use the Network to carry out any illegal activities, including but
            not limited to money laundering, terrorist financing
            or&nbsp;deliberately engaging in activities designed to adversely
            affect the performance of the Network, or&nbsp;the Service;&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            Engage in wash trading or&nbsp;other&nbsp;deceptive
            or&nbsp;manipulative trading activities on the Platform;&nbsp;
          </li>
          <li>Place misleading bids or&nbsp;offers;&nbsp;</li>
          <li>
            Use the Service to carry out any financial activities subject
            to&nbsp;registration or&nbsp;licensing, including but not limited to
            creating, listing, or&nbsp;buying securities, commodities,
            options,&nbsp;real estate, or&nbsp;debt instruments; or&nbsp;
          </li>
          <li>
            Use the Service to&nbsp;participate&nbsp;in fundraising for a
            business, protocol, or platform, including but not limited to
            creating, listing, or buying assets that are redeemable for
            financial instruments, assets that give&nbsp;owners'&nbsp;rights
            to&nbsp;participate&nbsp;in an ICO or any securities offering, or
            assets that entitle owners to financial rewards, including but not
            limited to,&nbsp;DeFi&nbsp;yield bonuses, staking bonuses, and burn
            discounts.&nbsp;
          </li>
        </ul>
        <ol>
          <li>
            Nzvedaz Big Five&nbsp;Token&nbsp;facilitates&nbsp;trade among a
            diverse community of buyers and sellers. Openness is one of our most
            prized values, and we are committed to&nbsp;providing&nbsp;a
            Platform for the exchange of Crypto Assets linked to controversial
            content. These policies ensure that the Platform offers the widest
            selection of assets possible while promoting trust and respect, as
            well as adherence to the law.&nbsp;Nzvedaz Big Five&nbsp;Token
            has&nbsp;always exercised judgment in allowing or disallowing
            certain assets, listings, smart contracts, and collections
            consistent with the spirit of openness in a worldwide community of
            users of a radical&nbsp;new technology. We carefully consider the
            complete situation and all its details&nbsp;considering&nbsp;our
            policies before deciding whether to remove inappropriate assets,
            listings, smart contracts, and collections when we discover them or
            they are brought to our attention.&nbsp;
          </li>
          <li>
            Crypto Assets linked to assets, listings, smart contracts, and
            collections that&nbsp;Nzvedaz Big
            Five&nbsp;Token&nbsp;deems&nbsp;inappropriate, disruptive, or
            illegal are prohibited on&nbsp;Nzvedaz Big
            Five&nbsp;Token.&nbsp;Nzvedaz Big Five&nbsp;Token reserves&nbsp;the
            right to&nbsp;determine&nbsp;the appropriateness of listings on its
            site and remove any listing at any time. If you create or offer an
            asset, listing, smart contract, or collection in violation of these
            policies, we will take corrective actions,
            as&nbsp;appropriate.&nbsp;Nzvedaz Big Five&nbsp;Token
            cannot&nbsp;destroy or impound your assets or smart contracts, but
            we reserve the right to destroy inappropriate metadata stored on our
            servers (as applicable).&nbsp;
          </li>
          <li>
            Crypto Assets linked to assets, listings, smart contracts, and
            collections that include metadata that violates international or UK
            intellectual property laws, promotes suicide or self-harm, incites
            hate or violence against others, degrades or doxes another
            individual, depicts minors in sexually suggestive situations, or is
            otherwise illegal in UK are prohibited on&nbsp;Nzvedaz Big
            Five&nbsp;Token and&nbsp;will be removed.&nbsp;
          </li>
          <li>
            Crypto Assets linked to assets, listings, smart contracts, and
            collections created or used primarily or substantially for the
            purpose of raising funds for the known terrorist organizations
            listed in the notice of the United Nations (Anti-Terrorism Measures)
            Ordinance (Cap. 575) as updated from time to
            time&nbsp;&nbsp;And&nbsp;on the&nbsp;
            <u>
              <a
                href="https://www.state.gov/foreign-terrorist-organizations/"
                className="link-dark"
              >
                https://www.state.gov/foreign-terrorist-organizations/
              </a>
            </u>
            are prohibited on the Platform and will be removed. The sale of
            Crypto Assets linked to stolen assets, assets taken without
            authorization, and otherwise illegally obtained assets
            on&nbsp;Nzvedaz Big Five&nbsp;Token is&nbsp;prohibited. If you have
            reason to believe that any Crypto Asset on our Platform is linked to
            an asset that was illegally obtained, please contact
            us&nbsp;immediately. Listing any Crypto Asset linked to illegally
            obtained assets will result in your listings being cancelled, your
            assets being hidden, or your Account being suspended.&nbsp;
          </li>
          <li>
            <strong>Age&nbsp;Restrictions and NSFW Content</strong>
          </li>
          <li>
            If the user&nbsp;is an individual, the user&nbsp;must be 18 years
            old or&nbsp;older&nbsp;and&nbsp;possess&nbsp;the capacity to form a
            binding contract and have the full capacity to accept these Terms,
            use the Service and conduct any Transactions. Anyone under&nbsp;18
            years old may use a parent or&nbsp;guardian's Account but only with
            permission and involvement of the Account owner. The Account
            owner&nbsp;assumes all associated&nbsp;risks
            and&nbsp;is&nbsp;responsible for&nbsp;everything performed with that
            Account.&nbsp;
          </li>
          <li>
            Crypto Assets linked to content that is&nbsp;
            <strong>&ldquo;Not Safe for Work&rdquo;</strong>or&nbsp;
            <strong>&ldquo;NSFW&rdquo;</strong>&nbsp;(
            <strong>&ldquo;NSFW Content&rdquo;</strong>) as defined
            and&nbsp;determined&nbsp;by&nbsp;Nzvedaz Big Five&nbsp;Token
            are&nbsp;meant for people who are 18 years and older. We allow the
            sale of NSFW Content, but it is subject to being marked NSFW and
            handled differently from non-NSFW Content in navigation menus and
            search results. Crypto Assets that&nbsp;contain&nbsp;NSFW Content
            are subject to being marked NSFW, even if the NSFW Content
            only&nbsp;represents&nbsp;a&nbsp;portion&nbsp;of the
            content.&nbsp;Nzvedaz Big Five&nbsp;Token may&nbsp;remove NSFW
            Content not marked as&nbsp;<strong>&ldquo;NSFW&rdquo;</strong>
            &nbsp;from the Platform at any time without giving you prior
            notice.&nbsp;
          </li>
          <li>
            <strong>User&nbsp;Information and Copyright</strong>
          </li>
          <li>
            You are solely&nbsp;responsible for&nbsp;your&nbsp;use of the
            Service and for&nbsp;any User&nbsp;Information you provide,
            including compliance with applicable laws,&nbsp;rules,
            and&nbsp;regulations. We take no&nbsp;responsibility for&nbsp;the
            User&nbsp;Information posted or&nbsp;listed via the Service.
            You&nbsp;retain&nbsp;your&nbsp;rights to any User&nbsp;Information
            you&nbsp;submit, post, or&nbsp;display using the Service.&nbsp;
          </li>
          <li>
            By submitting, posting or displaying User Information on or through
            the Service, you grant us a worldwide, non-exclusive, sublicensable,
            royalty-free license to use, copy, modify, and display any text,
            content, files, communications, comments, feedback, suggestions,
            ideas, concepts, questions, data or other content that you submit or
            post on the Platform and/or through the Service or through tools or
            applications we provide for posting or sharing such content
            (collectively&nbsp;<strong>&ldquo;User Information&rdquo;</strong>)
            for our lawful business purposes, including to provide, promote, and
            improve the Service.&nbsp;Nzvedaz Big Five&nbsp;Token does&nbsp;not
            claim that&nbsp;sending,&nbsp;posting&nbsp;or displaying User
            Information on the Platform and/or through the Service
            gives&nbsp;Nzvedaz Big Five&nbsp;Token any&nbsp;ownership or resale
            rights in your User Information.&nbsp;
          </li>
          <li>
            You&nbsp;represent&nbsp;and warrant that you have, or have obtained,
            all rights, licenses, consents, permissions, power and/or authority
            necessary to grant the rights granted&nbsp;herein&nbsp;for any User
            Information that you&nbsp;submit, post or display on the Platform
            and/or through the Service. You agree that such User Information
            will not&nbsp;contain&nbsp;material subject to copyright or other
            proprietary rights, unless you have necessary permission or are
            otherwise legally entitled to post the material and grant
            to&nbsp;Nzvedaz Big Five&nbsp;Token the&nbsp;license described
            above.&nbsp;
          </li>
          <li>
            Nzvedaz Big Five&nbsp;Token will&nbsp;remove content in response to
            formal infringement claims at any time without prior notice to the
            user and will&nbsp;terminate&nbsp;a user's access to the Service if
            the user is a repeat infringer.&nbsp;
          </li>
          <li>
            Formal infringement claims&nbsp;regarding&nbsp;content on the
            Service must include:&nbsp;
          </li>
          <li>
            Written communication detailing C to G (
            <strong>&ldquo;Infringement Notice&rdquo;</strong>) and addressed
            to&nbsp;legal@thebigfive.com.&nbsp;
          </li>
          <li>
            A physical or&nbsp;electronic signature of someone authorized to act
            on behalf of the copyright owner&nbsp;(if applicable);&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            Identification of the copyrighted work(s) allegedly infringed;&nbsp;
          </li>
        </ul>
        <ol>
          <li>
            Identification of material claimed to be infringing,&nbsp;reasonably
            sufficient&nbsp;to&nbsp;permit&nbsp;Nzvedaz Big Five&nbsp;Token
            to&nbsp;locate&nbsp;the material;&nbsp;
          </li>
          <li>
            Information&nbsp;reasonably
            sufficient&nbsp;to&nbsp;permit&nbsp;Nzvedaz Big Five&nbsp;Token
            to&nbsp;contact the complaining party. This can be an address, phone
            number, email address, or other suitable method of contact;&nbsp;
          </li>
          <li>
            A statement that the &ldquo;complaining party has a good faith
            belief that use of the material in the manner&nbsp;complained of is
            not authorized by the copyright owner, its agent or&nbsp;the
            law&rdquo;;&nbsp;and&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            A statement that the information in the Infringement Notice
            is&nbsp;accurate&nbsp;and, under penalty of&nbsp;lying under oath,
            that the complainant&nbsp;is authorized to&nbsp;act on behalf of
            copyright owner.&nbsp;
          </li>
        </ul>
        <ol start="17">
          <li>
            <strong>Indemnification</strong>
          </li>
        </ol>
        <p>
          To the fullest extent permitted by applicable law, you agree to
          indemnify, defend and hold harmless&nbsp;Nzvedaz Big Five Token&nbsp;,
          and our respective past, present and future employees, officers,
          directors, contractors, consultants, equity holders, suppliers,
          vendors, service providers, parent companies, subsidiaries,
          affiliates, agents, representatives, predecessors, successors and
          assigns (individually and collectively, the&nbsp;
          <strong>&ldquo;Nzvedaz Big Five Token&nbsp;Parties&rdquo;</strong>),
          from and against all actual or alleged third party claims, damages,
          awards, judgments, losses, liabilities, obligations, penalties,
          interest, fees, expenses (including, without limitation,
          attorneys&rsquo; fees and expenses) and costs (including, without
          limitation, debt collection expenses, court costs, costs of settlement
          and costs of pursuing indemnification and insurance), of every kind
          and nature whatsoever, whether known or unknown, foreseen or
          unforeseen, matured or unmatured, or suspected or unsuspected, in law
          or equity, whether in tort, contract or otherwise (collectively,&nbsp;
          <strong>&ldquo;Claims&rdquo;</strong>), including, but not limited to,
          damages to property or personal injury, that are caused by, arise out
          of or are related to:&nbsp;
        </p>
        <ol>
          <li>
            Your&nbsp;use or&nbsp;misuse of the Service, User&nbsp;Information
            or&nbsp;Crypto Assets;&nbsp;
          </li>
          <li>Your&nbsp;participation in any Transaction&nbsp;</li>
          <li>
            Any&nbsp;Representations and Warranties given by you being
            untrue;&nbsp;&nbsp;
          </li>
          <li>Any breach of any of these Terms; and&nbsp;</li>
          <li>
            Any claim against you by any third-party, including another user
            or&nbsp;MetaMask. You agree to promptly notify&nbsp;Nzvedaz Big
            Five&nbsp;Token of&nbsp;any third-party Claims and cooperate with
            the&nbsp;Big Five&nbsp;Token&nbsp;Parties&nbsp;in defending such
            Claims. You further agree that the&nbsp;Big
            Five&nbsp;Token&nbsp;Parties&nbsp;shall have control of the defense
            or settlement of any third-party Claims. THIS INDEMNITY IS IN
            ADDITION TO, AND NOT IN LIEU OF, ANY OTHER LEGAL RIGHTS AVAILABLE TO
            US INCLUDING ANY OTHER INDEMNITIES SET FORTH IN A WRITTEN AGREEMENT
            BETWEEN YOU AND&nbsp;THE BIG FIVE&nbsp;TOKEN.&nbsp;
          </li>
          <li>
            <strong>Disclaimers</strong>
          </li>
          <li>
            EXCEPT AS EXPRESSLY PROVIDED TO THE CONTRARY IN WRITING BY&nbsp;THE
            BIG FIVE&nbsp;TOKEN,&nbsp;THE SERVICE, CONTENT CONTAINED THEREIN,
            AND CRYPTO ASSETS LISTED THEREIN ARE PROVIDED ON AN&nbsp;
            <strong>&ldquo;AS IS&rdquo;</strong>AND &ldquo;AS AVAILABLE&rdquo;
            BASIS WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, EITHER EXPRESS
            OR IMPLIED.&nbsp;THE BIG FIVE&nbsp;TOKEN MAKE&nbsp;NO WARRANTY THAT
            THE SERVICE: (A) WILL MEET YOUR REQUIREMENTS; (B) WILL BE AVAILABLE
            ON AN UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE BASIS; OR (C)
            WILL BE ACCURATE, RELIABLE, COMPLETE, LEGAL, OR SAFE.&nbsp;THE BIG
            FIVE&nbsp;TOKEN DISCLAIMS&nbsp;ALL OTHER WARRANTIES OR CONDITIONS,
            EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED
            WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT AS TO THE SERVICE,
            CONTENT CONTAINED THEREIN. WE WILL NOT BE LIABLE FOR ANY LOSS OF ANY
            KIND FROM ANY ACTION TAKEN OR TAKEN IN RELIANCE ON MATERIAL OR
            INFORMATION, CONTAINED ON THE PLATFORM. WHILE&nbsp;THE BIG
            FIVE&nbsp;TOKEN ATTEMPTS&nbsp;TO MAKE YOUR ACCESS TO AND USE OF THE
            SERVICE AND CONTENT SAFE,&nbsp;THE BIG FIVE&nbsp;TOKEN
            CANNOT&nbsp;AND DOES NOT REPRESENT OR WARRANT THAT THE SERVICE,
            CONTENT, ANY CRYPTO ASSETS LISTED ON OUR SERVICE OR OUR SERVERS ARE
            FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WE CANNOT GUARANTEE THE
            SECURITY OF ANY DATA THAT YOU DISCLOSE ONLINE. YOU ACCEPT THE
            INHERENT SECURITY RISKS OF PROVIDING INFORMATION AND DEALING ONLINE
            OVER THE INTERNET AND WILL NOT HOLD US RESPONSIBLE FOR ANY BREACH OF
            SECURITY UNLESS IT IS DUE TO OUR GROSS NEGLIGENCE.&nbsp;
          </li>
          <li>
            GIVEN THAT THE PLATFORM IS OPERATING IN A DECENTRALIZED MANNER,
            THERE WILL BE MINIMUM INTERFERENCE FROM&nbsp;THE BIG FIVE&nbsp;TOKEN
            IN&nbsp;THE OPERATION OF THE PLATFORM. ONCE A TRANSACTION HAS BEEN
            INITIATED BY A USER THAT RESULTS IN A BROADCAST TO THE NETWORK, IT
            WILL NOT BE POSSIBLE NOR WOULD IT BE&nbsp;THE BIG FIVE
            TOKEN&nbsp;&rsquo;S RESPONSIBILITY TO HALT ANY TRANSACTION SHOULD
            THE USER SUBSEQUENTLY DISCOVER THAT THE TRANSACTION HAS BEEN MADE TO
            AN INCORRECT WALLET ADDRESS. IT IS YOUR RESPONSIBILITY TO CHECK ALL
            DETAILS OF THE TRANSACTION PRIOR TO PROCEEDING.&nbsp;
          </li>
          <li>
            YOU ACCEPT RESPONSIBILITIES FOR ALL YOUR ACTIVITIES AND CONTENTS ON
            THE PLATFORM INCLUDING TRANSACTIONS. YOU FURTHER ACKNOWLEDGE
            THAT&nbsp;THE BIG FIVE&nbsp;TOKEN DOES&nbsp;NOT ACT AS YOUR BROKER,
            INTERMEDIARY, AGENT, ADVISOR OR CREDITOR WITH RESPECT TO ANY
            TRANSACTION YOU AKE OR PROPOSE TO MAKE ON THE PLATFORM AND OWES YOU
            NO FIDUCIARY DUTY. ANY COMMUNICATION BY&nbsp;THE BIG FIVE&nbsp;TOKEN
            TO&nbsp;YOU SHALL NOT BE CONSTRUED UNDER ANY CIRCUMSTANCES AS LEGAL,
            TAX, ACCOUNTING OR FINANCIAL ADVICE.&nbsp;
          </li>
          <li>
            THE BIG FIVE&nbsp;TOKEN ONLY&nbsp;PROVIDES A PLATFORM TO FACILITATE
            TRANSACTIONS BETWEEN THE BUYER AND SELLER BUT IS NOT A PARTY TO ANY
            TRANSACTION OR AGREEMENT BETWEEN THE BUYER AND SELLER OF CRYPTO
            ASSETS OR BETWEEN ANY USERS. YOU BEAR FULL RESPONSIBILITY FOR
            VERIFYING THE IDENTITY, LEGITIMACY, AND AUTHENTICITY OF CRYPTO
            ASSETS YOU PURCHASE ON THE PLATFORM. NOTWITHSTANDING INDICATORS AND
            MESSAGES THAT SUGGEST VERIFICATION,&nbsp;THE BIG FIVE&nbsp;TOKEN
            MAKES&nbsp;NO CLAIMS ABOUT THE IDENTITY, LEGITIMACY, OR AUTHENTICITY
            OF CRYPTO ASSETS ON THE PLATFORM.&nbsp;
          </li>
          <li>
            WE WILL NOT BE&nbsp;RESPONSIBLE OR&nbsp;LIABLE TO YOU FOR&nbsp;ANY
            LOSS AND TAKE NO&nbsp;RESPONSIBILITY FOR, AND WILL NOT BE LIABLE TO
            YOU FOR, ANY USE OF CRYPTO ASSETS, INCLUDING BUT NOT LIMITED TO ANY
            LOSSES, DAMAGES OR&nbsp;CLAIMS ARISING FROM:&nbsp;
          </li>
          <li>
            USER&nbsp;ERROR&nbsp;SUCH AS FORGOTTEN PASSWORDS, INCORRECTLY
            CONSTRUCTED TRANSACTIONS, OR&nbsp;MISTYPED ADDRESSES;&nbsp;
          </li>
          <li>SERVER&nbsp;FAILURE OR&nbsp;DATA LOSS;&nbsp;&nbsp;</li>
        </ol>
        <ul>
          <li>CORRUPTED WALLET FILES;&nbsp;&nbsp;</li>
        </ul>
        <ol>
          <li>UNAUTHORIZED ACCESS TO YOUR&nbsp;ACCOUNT; OR&nbsp;</li>
          <li>
            ANY UNAUTHORIZED&nbsp;THIRD-PARTY&nbsp;ACTIVITIES, INCLUDING WITHOUT
            LIMITATION THE USE OF VIRUSES, PHISHING, BRUTEFORCING OR OTHER MEANS
            OF ATTACK AGAINST THE SERVICE OR CRYPTO ASSETS.&nbsp;
          </li>
          <li>
            CRYPTO ASSETS ARE INTANGIBLE DIGITAL ASSETS. THEY EXIST ONLY BY
            VIRTUE OF THE OWNERSHIP RECORD MAINTAINED IN THE NETWORK. ANY
            TRANSFER OF TITLE THAT MIGHT OCCUR IN ANY UNIQUE DIGITAL ASSET
            OCCURS ON THE DECENTRALIZED LEDGER WITHIN THE NETWORK. WE DO NOT
            GUARANTEE THAT&nbsp;THE BIG FIVE&nbsp;TOKEN OR&nbsp;ANY&nbsp;THE BIG
            FIVE&nbsp;TOKEN PARTY&nbsp;CAN&nbsp;AFFECT&nbsp;THE TRANSFER OF
            TITLE OR RIGHT IN ANY CRYPTO ASSETS.&nbsp;
          </li>
          <li>
            THE BIG FIVE&nbsp;TOKEN IS&nbsp;NOT RESPONSIBLE FOR LOSSES ARISING
            OUT OF OR RELATING TO VULNERABILITY OR ANY KIND OF FAILURE, ABNORMAL
            BEHAVIOR OF SOFTWARE (E.G., WALLET, SMART CONTRACT), BLOCKCHAINS OR
            ANY OTHER FEATURES OF THE CRYPTO ASSETS.&nbsp;THE BIG
            FIVE&nbsp;TOKEN IS&nbsp;NOT RESPONSIBLE FOR LOSSES ARISING OUT OF OR
            RELATING TO LATE REPORT BY DEVELOPERS OR REPRESENTATIVES (OR NO
            REPORT AT ALL) OF ANY ISSUES WITH THE BLOCKCHAIN SUPPORTING CRYPTO
            ASSETS INCLUDING FORKS, TECHNICAL NODE ISSUES OR ANY OTHER ISSUES
            HAVING FUND LOSSES AS A RESULT.&nbsp;
          </li>
          <li>
            THE CHARACTERISTICS OF THE CRYPTO ASSETS CREATED THROUGH THE SERVICE
            ON OUR PLATFORM SHALL BE DETERMINED BY THE CREATOR.&nbsp;THE BIG
            FIVE&nbsp;TOKEN HAS&nbsp;NO INVOLVEMENT OR RESPONSIBILITY IN THE
            DESIGN OF THE CRYPTO ASSET.&nbsp;
          </li>
          <li>
            <strong>Assumption of&nbsp;Risk You accept and acknowledge:</strong>
          </li>
          <li>
            The prices of blockchain assets are extremely volatile. Fluctuations
            in the price of other&nbsp;digital assets could materially and
            adversely affect the Crypto Assets, which may also be subject to
            significant price volatility. We cannot guarantee that any
            purchasers of Crypto Assets will not lose money.&nbsp;
          </li>
          <li>
            You are solely responsible for&nbsp;determining&nbsp;what, if any,
            taxes apply to your Transactions which includes, but is not limited
            to any income, profit and/or capital gains tax. Neither&nbsp;Nzvedaz
            Big Five&nbsp;Token nor&nbsp;any other&nbsp;Nzvedaz Big
            Five&nbsp;Token Party&nbsp;is responsible
            for&nbsp;determining&nbsp;the taxes that apply to Transactions nor
            will they&nbsp;supply&nbsp;any tax related information to the
            users.&nbsp;
          </li>
          <li>
            Nzvedaz Big Five&nbsp;Token does&nbsp;not store, send, or receive
            Crypto Assets. This is because Crypto Assets exist only by virtue of
            the ownership record&nbsp;kept&nbsp;on its supporting blockchain.
            Any transfer of Crypto Assets occurs within the supporting
            blockchain and not on this Service.&nbsp;
          </li>
          <li>
            There are risks associated with using an Internet based currency,
            including but not limited to, the risk of hardware, software and
            Internet connections, the risk of malicious software introduction,
            and the risk that third parties may obtain unauthorized access to
            information stored within your Account. You accept and acknowledge
            that&nbsp;Nzvedaz Big Five&nbsp;Token will&nbsp;not be responsible
            for any communication failures, disruptions, errors, distortions or
            delays you may experience when using the Service, however
            caused.&nbsp;
          </li>
          <li>
            A lack of use or public interest in the creation and development of
            distributed ecosystems could negatively&nbsp;affect&nbsp;the
            development of those ecosystems and related applications and could
            therefore also negatively&nbsp;affect&nbsp;the potential utility or
            value of Crypto Assets.&nbsp;
          </li>
          <li>
            The&nbsp;regulatory&nbsp;regime governing blockchain technologies,
            cryptocurrencies, and tokens is uncertain, and new&nbsp;regulations
            or&nbsp;policies may materially adversely affect the development of
            the Service and the utility of Crypto Assets.&nbsp;
          </li>
          <li>
            The Service will&nbsp;rely on third-party platforms such
            as&nbsp;MetaMask&nbsp;to perform the Transactions. If:&nbsp;
          </li>
          <li>
            we are unable to&nbsp;keep&nbsp;a good relationship with such
            platform providers;&nbsp;
          </li>
          <li>
            the terms and conditions or pricing of such
            platform&nbsp;provider's&nbsp;change;&nbsp;&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            we violate or cannot&nbsp;follow&nbsp;the terms and conditions of
            such platforms; or&nbsp;&nbsp;
          </li>
        </ul>
        <ol>
          <li>
            if any of such platforms loses market share or falls out of favor or
            is unavailable for a prolonged&nbsp;period, access to and use of the
            Service will suffer.&nbsp;
          </li>
          <li>
            There are risks associated with&nbsp;buying&nbsp;Crypto Assets,
            including but not limited to, the risk
            of&nbsp;buying&nbsp;counterfeit assets, mislabeled assets, assets
            that are vulnerable to metadata decay, assets on smart contracts
            with bugs, and assets that may become untransferable.&nbsp;Nzvedaz
            Big Five&nbsp;Token reserves&nbsp;the right to hide collections,
            contracts, and Crypto Assets affected by any of these issues or by
            other issues. Crypto Assets you&nbsp;buy&nbsp;may become
            inaccessible on&nbsp;Nzvedaz Big Five&nbsp;Token.&nbsp;Under no
            circumstances shall the inability to view your assets
            on&nbsp;Nzvedaz Big Five&nbsp;Token serve&nbsp;as grounds for a
            claim against&nbsp;Nzvedaz Big Five&nbsp;Token.&nbsp;
          </li>
          <li>
            <strong>Limitation of Liability</strong>
          </li>
          <li>
            WE WILL NOT BE LIABLE TO YOU OR&nbsp;ANY THIRD PARTY FOR&nbsp;ANY
            DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL
            OR&nbsp;EXEMPLARY DAMAGES (INCLUDING DAMAGES FOR&nbsp;LOSS OF
            PROFITS, GOODWILL, USE, OR&nbsp;DATA), EVEN IF A PARTY HAS BEEN
            ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. FURTHER, WE WILL NOT
            BE&nbsp;RESPONSIBLE FOR&nbsp;ANY COMPENSATION,&nbsp;REIMBURSEMENT,
            OR&nbsp;DAMAGES ARISING IN CONNECTION WITH YOUR&nbsp;INABILITY TO
            USE THE SERVICE OR&nbsp;PLATFORM, INCLUDING AS A&nbsp;RESULT
            OF:&nbsp;
          </li>
          <li>
            ANY TERMINATION OR&nbsp;SUSPENSION OF THE SERVICE;&nbsp;&nbsp;
          </li>
          <li>
            OUR&nbsp;DISCONTINUATION OF ANY OR&nbsp;ALL OF THE SERVICE
            AND/OR&nbsp;PLATFORM; OR&nbsp;&nbsp;
          </li>
        </ol>
        <ul>
          <li>
            WITHOUT LIMITING ANY OBLIGATIONS UNDER&nbsp;ANY SEPARATELY AGREED
            SERVICE-LEVEL AGREEMENTS, ANY UNANTICIPATED OR&nbsp;UNSCHEDULED
            DOWNTIME OF ALL OR&nbsp;A PORTION OF THE PLATFORM
            AND/OR&nbsp;SERVICE OR&nbsp;PLATFORM FOR&nbsp;ANY&nbsp;REASON,
            INCLUDING AS A&nbsp;RESULT OF:&nbsp;
          </li>
        </ul>
        <ol>
          <li>
            POWER&nbsp;OUTAGES, SYSTEM FAILURES
            OR&nbsp;OTHER&nbsp;INTERRUPTIONS;&nbsp;
          </li>
          <li>
            THE COST OF PROCUREMENT OF SUBSTITUTE GOODS OR&nbsp;THE SERVICE
            OR&nbsp;PLATFORM;&nbsp;&nbsp;
          </li>
          <li>
            ANY INVESTMENTS, EXPENDITURES, OR&nbsp;COMMITMENTS BY YOU
            OR&nbsp;YOUR&nbsp;USE OF OR&nbsp;ACCESS TO THE SERVICE OR&nbsp;THE
            PLATFORM; OR&nbsp;
          </li>
          <li>
            ANY UNAUTHORIZED ACCESS TO, ALTERATION OF, OR&nbsp;THE DELETION,
            DESTRUCTION, DAMAGE, LOSS OR&nbsp;FAILURE TO STORE ANY OF
            YOUR&nbsp;CONTENT OR&nbsp;OTHER&nbsp;DATA.&nbsp;
          </li>
          <li>
            NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, IN NO
            EVENT SHALL THE MAXIMUM AGGREGATE LIABILITY OF&nbsp;THE BIG
            FIVE&nbsp;TOKEN ARISING&nbsp;OUT OF OR IN ANY WAY RELATED TO THESE
            TERMS, THE ACCESS TO THE PLATFORM AND/OR USE OF THE SERVICE,
            CONTENT, CRYPTO ASSETS, OR ANY CRYPTO ASSETS PURCHASED ON THE
            PLATFORM EXCEED THE AMOUNT RECEIVED BY&nbsp;THE BIG FIVE&nbsp;TOKEN
            FROM&nbsp;THE SALE OF CRYPTO ASSETS ON THE PLATFORM THAT ARE THE
            SUBJECT OF THE CLAIM. THE FOREGOING LIMITATIONS OF LIABILITY SHALL
            NOT APPLY TO:&nbsp;
          </li>
          <li>
            DEATH OR PERSONAL INJURY CAUSED BY&nbsp;THE BIG FIVE&nbsp;TOKEN
            OR&nbsp;THE BIG FIVE&nbsp;TOKEN PARTIES&rsquo; NEGLIGENCE;
            OR&nbsp;&nbsp;
          </li>
          <li>
            ANY INJURY CAUSED BY A&nbsp;THE BIG FIVE&nbsp;TOKEN OR&nbsp;THE BIG
            FIVE&nbsp;TOKEN PARTIES&rsquo; FRAUD OR FRAUDULENT
            MISREPRESENTATION.&nbsp;
          </li>
          <li>
            NOTHING IN THESE TERMS SHALL EXCLUDE OR&nbsp;LIMIT LIABILITY OF
            EITHER&nbsp;PARTY FOR&nbsp;FRAUD, DEATH OR&nbsp;BODILY INJURY CAUSED
            BY NEGLIGENCE, VIOLATION OF LAWS, OR&nbsp;ANY OTHER&nbsp;ACTIVITY
            THAT CANNOT BE LIMITED OR&nbsp;EXCLUDED BY LEGITIMATE MEANS.&nbsp;
          </li>
          <li>
            Some jurisdictions do not allow the exclusion or&nbsp;limitation of
            incidental or&nbsp;consequential damages, so the above limitation
            or&nbsp;exclusion may not apply to you. Some jurisdictions also
            limit disclaimers or&nbsp;limitations of liability for&nbsp;personal
            injury from consumer&nbsp;products, so this limitation may not apply
            to personal injury claims.&nbsp;
          </li>
          <li>
            <strong>Assignment</strong>
          </li>
        </ol>
        <p>
          You may not assign or transfer any of your obligations or rights
          without the written consent from&nbsp;Nzvedaz Big
          Five&nbsp;Token.&nbsp;
        </p>
        <ol start="22">
          <li>
            <strong>Force Majeure</strong>
          </li>
        </ol>
        <p>
          Nzvedaz Big Five&nbsp;Token shall&nbsp;not be liable for any delay or
          failure to perform its obligations under these Terms which is caused
          by an event or sequence of events beyond its reasonable control. Such
          events shall include acts of God, flood, drought, earthquake or other
          natural disaster; disease, epidemic or pandemic such as COVID-19 and
          the lockdown of territories or states as a result of the pandemic;
          terrorist attack, civil war, civil commotion or riots, war, threat of
          or preparation for war, armed conflict, imposition of sanctions,
          embargo, or breaking off of diplomatic relations; nuclear, chemical or
          biological contamination; any law or any action taken by a government
          or public authority, including without limitation imposing an export
          or import restriction, quota or prohibition, or failing to grant or
          renew a necessary&nbsp;licence&nbsp;or consent; collapse of buildings,
          fire, explosion or accident; any&nbsp;labour&nbsp;or trade dispute,
          strikes, industrial action or lockouts; and interruption or failure of
          utility service.&nbsp;
        </p>
        <ol start="23">
          <li>
            <strong>Headings</strong>
          </li>
        </ol>
        <p>
          Headings are inserted for&nbsp;convenience and not to be used when
          interpreting the Terms.&nbsp;
        </p>
        <ol start="24">
          <li>
            <strong>Language</strong>
          </li>
        </ol>
        <p>
          Notwithstanding any other provision of these Terms, any translation of
          the Terms is&nbsp;supplied&nbsp;for your convenience. The meanings of
          terms,&nbsp;conditions&nbsp;and representations&nbsp;here&nbsp;are
          subject to definitions and interpretations in English. You agree
          that&nbsp;if&nbsp;any conflict between the English version of the
          foregoing documents and any other translations, the English version
          shall prevail.&nbsp;
        </p>
        <ol start="25">
          <li>
            <strong>No Partnership</strong>
          </li>
        </ol>
        <p>
          Nzvedaz Big Five&nbsp;Token and&nbsp;the user are and intend to remain
          independent parties. Nothing in these Terms shall
          be&nbsp;considered&nbsp;or construed to create the relationship of a
          principal and agent or partnership or joint venture, or that of an
          employee and employer between&nbsp;Nzvedaz Big Five&nbsp;Token
          and&nbsp;the user and&nbsp;Nzvedaz Big Five&nbsp;Token shall&nbsp;not
          assume any fiduciary duties to the user.&nbsp;
        </p>
        <ol start="26">
          <li>
            <strong>Governing Law and Venue</strong>
          </li>
        </ol>
        <p>
          These Terms, your access to and use of the Service and Content, and
          your participation in the Auction shall be governed by the laws of
          England &amp; Wales Laws as to all matters including validity,
          construction, effect,&nbsp;performance&nbsp;and remedies without
          regard to the conflict of law rules or principles of any
          other&nbsp;authority).&nbsp;
        </p>
        <ol start="27">
          <li>
            <strong>Dispute&nbsp;Resolution; Arbitration.</strong>
          </li>
        </ol>
        <p>
          Any dispute which cannot be resolved as provided in paragraph 26 above
          shall be referred to and finally resolved by arbitration administered
          by the London Court of International Arbitration LCIA The law of this
          arbitration clause shall be England &amp; Wales law. The place of
          arbitration shall be United Kingdom. The number of arbitrators shall
          [1]. The arbitration proceedings shall be conducted in English.&nbsp;
        </p>
        <ol start="28">
          <li>
            <strong>Termination</strong>
          </li>
        </ol>
        <p>
          Notwithstanding anything contained in these Terms, we reserve the
          right, without notice and in our sole discretion,
          to&nbsp;end&nbsp;your right to access or use the Service at any time
          and for any or no reason, and you acknowledge and agree that we shall
          have no liability or obligation to you in such event and that you will
          not be entitled to a refund of any amounts that you have already paid
          to us, to the fullest extent&nbsp;allowed&nbsp;by applicable
          law.&nbsp;
        </p>
        <ol start="29">
          <li>
            <strong>Severability</strong>
          </li>
        </ol>
        <p>
          If any term,&nbsp;clause&nbsp;or&nbsp;provision of these Terms is held
          invalid or&nbsp;unenforceable, then that term, clause
          or&nbsp;provision will be severable from these Terms and will not
          affect the validity or&nbsp;enforceability of any&nbsp;remaining part
          of that term, clause or&nbsp;provision, or&nbsp;any
          other&nbsp;term,&nbsp;clause&nbsp;or&nbsp;provision of these
          Terms.&nbsp;
        </p>
        <ol start="30">
          <li>
            <strong>Survival</strong>
          </li>
        </ol>
        <p>
          The following sections will survive the&nbsp;end&nbsp;or termination
          of these Terms and the termination of your Account: all defined terms
          and Sections 1-3 and 7-32.&nbsp;
        </p>
        <ol start="31">
          <li>
            <strong>Third Party&nbsp;Rights</strong>
          </li>
        </ol>
        <p>
          The provisions of Contracts (Rights of Third Parties) Act 1999 United
          Kingdom are hereby expressly excluded from these Terms and/or&nbsp;any
          other&nbsp;documents issued pursuant thereto.&nbsp;
        </p>
        <ol start="32">
          <li>
            <strong>Miscellaneous</strong>
          </li>
        </ol>
        <p>
          These Terms, together with the Privacy Policy, constitute the entire
          agreement between you and&nbsp;Nzvedaz Big Five&nbsp;Token
          relating&nbsp;to your access to the Platform and use of the Service.
          These Terms, and any rights and licenses granted hereunder, may not be
          transferred or assigned by you without the prior written consent
          of&nbsp;Nzvedaz Big Five&nbsp;Token prior, concurrent or subsequent
          circumstance, and&nbsp;Nzvedaz Big Five Token&nbsp;&rsquo;s failure to
          assert any right or provision under these Terms shall not constitute a
          waiver of such right or provision. Except as
          otherwise&nbsp;supplied&nbsp;here, these Terms are intended solely for
          the benefit of the parties and are not intended to confer third-party
          beneficiary rights upon any other person or entity.&nbsp;
        </p>
        <p>END OF AGREEMENT</p>
      </div>
      <Top />
    </div>
  );
};

export default Terms;
